export const TextBoxMode = {
  NUMBER: 'number',
  TEXT: 'text',
  EMAIL: 'email',
  TEXT_AREA: 'textarea',
  PASSWORD: 'password',
};

export const TextBoxDecoration = {
  NONE: 'none',
  ICON: 'icon',
  COUNTER: 'counter',
  UNIT: 'unit',
};

export const Size = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
};

export const Variant = {
  STANDARD: 'standard',
  OUTLINE: 'outline',
  PLAIN: 'plain',
};

export const HintType = {
  INFORMATION: 'information',
};

export const Type = {
  BASIC: 'basic',
  DANGER: 'danger',
  POSITIVE: 'positive',
};
